export default "__VITE_ASSET__B_$iRaa6__"